import { render, staticRenderFns } from "./VesselDetails.vue?vue&type=template&id=188a9474&"
import script from "./VesselDetails.vue?vue&type=script&lang=js&"
export * from "./VesselDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports